var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Scoreboard = /** @class */ (function (_super) {
    __extends(Scoreboard, _super);
    function Scoreboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scoreboard.prototype.renderTableScoreInformation = function (scoreInfo) {
        return scoreInfo.map(function (item, index) {
            return React.createElement("td", { key: index, className: "rj-scoreboard__score-info" }, item);
        });
    };
    Scoreboard.prototype.renderTableTotalInformation = function (totalInfo) {
        return React.createElement("td", { className: "rj-scoreboard__total-info" }, totalInfo);
    };
    Scoreboard.prototype.render = function () {
        return (React.createElement("table", { className: "rj-scoreboard" + (this.props.modifier ? " rj-scoreboard--" + this.props.modifier : "") },
            React.createElement("tbody", null,
                React.createElement("tr", { className: "rj-scoreboard__players" },
                    this.renderTableScoreInformation(this.props.scoreFirstPlayer),
                    this.renderTableTotalInformation(this.props.totalFirstPlayer)),
                React.createElement("tr", { className: "rj-scoreboard__players" },
                    this.renderTableScoreInformation(this.props.scoreSecondPlayer),
                    this.renderTableTotalInformation(this.props.totalSecondPlayer)))));
    };
    return Scoreboard;
}(React.Component));
export { Scoreboard };
//# sourceMappingURL=Scoreboard.js.map